var filter = {
  //时间格式化 <p>{{'/Date(1493027950023)/' | datetimeFormat('yyyy/MM/dd hh:mm:ss')}}</p>
  // this.$options.filters['datetimeFormat']
  getDate: function(date) {
    if (typeof date === "string") {
      var mts = date.match(/(\/Date\((\d+)\)\/)/);
      if (mts && mts.length >= 3) {
        date = parseInt(mts[2]);
      }
    }
    date = new Date(date);
    return date;
  },
  datetimeFormat: function(date, format) {
    date = filter.getDate(date);
    if (!date || date.toUTCString() == "Invalid Date") {
      return "";
    }
    var map = {
      M: date.getMonth() + 1, //月份
      d: date.getDate(), //日
      h: date.getHours(), //小时
      m: date.getMinutes(), //分
      s: date.getSeconds(), //秒
      q: Math.floor((date.getMonth() + 3) / 3), //季度
      S: date.getMilliseconds(), //毫秒
    };
    format = format.replace(/([yMdhmsqS])+/g, function(all, t) {
      var v = map[t];

      if (v !== undefined) {
        if (all.length > 1) {
          v = "0" + v;
          v = v.substr(v.length - 2);
        }
        return v;
      } else if (t === "y") {
        return (date.getFullYear() + "").substr(4 - all.length);
      }
      return all;
    });
    return format;
  },
  // v-bind:style="item.HeadImgUrl | productimgFormat(300,300,true)"
  ossFormat: function(src, w, h, isbg) {
    if (!src) return;
    if (src.indexOf("oss.fjdaze.com") < 0) {
      src = "https://oss.fjdaze.com/" + src;
    }
    var imgurl = src + "?x-oss-process=image/resize,m_fill,h_" + h + ",w_" + w + "/format,png";

    if (isbg) {
      return "background-image:url(" + imgurl + ")";
    }
    return imgurl;
  },
  moneyFormat: function(val) {
    if (val - 0) {
      return (val - 0).toFixed(2);
    } else {
      return val;
    }
  },
};

export default {
  install: function(Vue) {
    for (var filteritem in filter) {
      Vue.filter(filteritem, filter[filteritem]);
    }
  },
};
